import { React, useState, useRef } from "react";
import axiosInstance from "../../../utils/axiosInstance";

const MarketAnalysisBetfairFancy = ({
  eventDetails,
  betfairFancyData,
  betfairFancyOddsData
}) => {
  const [showSessionPlPopup, setShowSessionPlPopup] = useState(false);
  const [sessionPLList, setSessionPLList] = useState({});
  const [sessionName, setSessionName] = useState("");
  const [sessionLoading, setSessionLoading] = useState(false);

  const isBetPlace = (fancyBookData, marketid) => {
    let found = false;
    if (fancyBookData == null || fancyBookData == undefined) {
      found = false;
    } else {
      fancyBookData?.find((item) =>
        item.marketid == marketid ? (found = true) : (found = false)
      );
    }
    return found;
  };

  const getColor = (amount) => {
    if (amount < 0) {
      return "position-minus";
    } else {
      return "position-plus";
    }
  };

  const closeSessionPlSlip = () => {
    setShowSessionPlPopup(false);
    setSessionPLList({});
    setSessionLoading(false);
  };

  const showFullBook = async (teamName, sid, evt_id) => {
    setSessionName(teamName);
    setSessionPLList({});
    setSessionLoading(true);
    setShowSessionPlPopup(true);

    try {
      const response = await axiosInstance.post("/games/get-sessionPL", {
        eid: evt_id,
        mid: sid,
        rname: teamName
      });

      if (
        response.data !== null &&
        response.data !== undefined &&
        response.data[0] !== "" &&
        response.data[0] !== null &&
        response.data[0] !== undefined
      ) {
        setSessionPLList(response.data[0]);
      }
    } catch (error) {
      console.error("Error fetching session book:", error);
    } finally {
      setSessionLoading(false);
    }
  };

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  return (
    <div>
      <div style={{ display: "block", backgroundColor: "transparnet" }}>
        <div
          style={{
            marginTop: "20px",
            display: "block",
            backgroundColor: "transparnet"
          }}
        >
          <div style={{ backgroundColor: "transparnet" }}>
            <div
              className="card card-accent-danger"
              style={{ marginBottom: "0px" }}
            >
              <div className="row bg-gray-100 market-head">
                <div className="col-12">
                  <strong>Betfair Fancy</strong>
                </div>
              </div>
            </div>
            <div
              class="market-runners"
              style={{
                borderLeft: "solid 1px #808080",
                borderRight: "solid 1px #808080",
                borderBottom: "solid 1px #808080"
              }}
            >
              <div>
                {betfairFancyData !== null &&
                  betfairFancyData !== undefined &&
                  betfairFancyData !== "" &&
                  betfairFancyData.map((fancy) => (
                    <div class="row runners" style={{ background: "white" }}>
                      <div class="col-7 runner-name">
                        <div>
                          <strong className="site_family">
                            {" "}
                            {fancy.market}
                            <div
                              style={{
                                display: isBetPlace(
                                  betfairFancyOddsData,
                                  fancy.marketid
                                )
                                  ? ""
                                  : "none"
                              }}
                            >
                              <span
                                className="site_family"
                                style={{ fontWeight: "bold", color: "red" }}
                              >
                                {formatTruncate(
                                  Math.round(
                                    (betfairFancyOddsData?.find(
                                      (item) => item.marketid == fancy.marketid
                                    )?.bak || 0) * -1
                                  )
                                )}
                              </span>{" "}
                              <span
                                className="site_family"
                                style={{
                                  fontWeight: "bold",
                                  paddingLeft: "8px",
                                  color: "green"
                                }}
                              >
                                {formatTruncate(
                                  Math.round(
                                    (betfairFancyOddsData?.find(
                                      (item) => item.marketid == fancy.marketid
                                    )?.lay || 0) * -1
                                  )
                                )}
                              </span>
                            </div>
                          </strong>
                        </div>
                        <div>
                          <a
                            href="#"
                            class="btn btn-link btn-fullBook site_family"
                            onClick={(e) => {
                              e.preventDefault();
                              showFullBook(
                                fancy.market,
                                fancy.marketid,
                                fancy.evt_id || eventDetails?.evt_id
                              );
                            }}
                          >
                            Full Book
                          </a>
                        </div>
                      </div>

                      <div class="col-5 col-md-8 price">
                        <div class="row">
                          <div class="col-md-2 d-none d-md-block cta-back">
                            <div id="b3-1" class="col-12 price"></div>
                            <div id="bs3-1" class="col-12 size"></div>
                          </div>
                          <div class="col-md-2 d-none d-md-block cta-back">
                            <div
                              id="b2-1"
                              class="col-md-12 col-sm-12 price"
                            ></div>
                            <div
                              id="bs2-1"
                              class="col-md-12 col-sm-12 size"
                            ></div>
                          </div>
                          <div class="col-6 col-md-2 cta-back">
                            <div id="b1-1" class="col-12 price site_family">
                              {fancy.bak}
                            </div>
                            <div id="bs1-1" class="col-12 size site_family">
                              {fancy.bakrate}
                            </div>
                          </div>
                          <div class="col-6 col-md-2 cta-lay">
                            <div
                              id="l1-1"
                              class="col-md-12 col-sm-12 price site_family"
                            >
                              {fancy.lay}
                            </div>
                            <div
                              id="ls1-1"
                              class="col-md-12 col-sm-12 size site_family"
                            >
                              {fancy.layrate}
                            </div>
                          </div>
                          <div class="col-md-2 d-none d-md-block cta-lay site_family">
                            <div
                              id="l2-1"
                              class="col-md-12 col-sm-12 price"
                            ></div>
                            <div
                              id="ls2-1"
                              class="col-md-12 col-sm-12 size"
                            ></div>
                          </div>
                          <div class="col-md-2 d-none d-md-block cta-lay">
                            <div
                              id="l3-1"
                              class="col-md-12 col-sm-12 price"
                            ></div>
                            <div
                              id="ls3-1"
                              class="col-md-12 col-sm-12 size"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {showSessionPlPopup && (
        <div>
          <div className="modal d-block">
            <div className="modal-dialog">
              <div className="modal-content" style={{ width: "99%" }}>
                <div style={{ borderRadius: "6px", background: "white" }}>
                  <table style={{ width: "100%" }}>
                    <tr>
                      <td>
                        <span
                          style={{
                            paddingTop: "13px",
                            paddingLeft: "13px",
                            paddingBottom: "0px",
                            fontSize: "18px",
                            fontWeight: "bold",
                            color: "black"
                          }}
                        >
                          {sessionName}
                        </span>
                      </td>
                      <td style={{ textAlign: "right", paddingRight: "13px" }}>
                        <button
                          type="button"
                          data-dismiss="modal"
                          aria-label="Close"
                          class="close"
                          onClick={() => closeSessionPlSlip()}
                        >
                          <span aria-hidden="true">×</span>
                        </button>
                      </td>
                    </tr>
                  </table>

                  <div
                    className="modal-body"
                    style={{ height: "500px", overflowX: "auto" }}
                  >
                    {sessionLoading ? (
                      <div style={{ color: "black", padding: "13px" }}>
                        Please wait Loading....
                      </div>
                    ) : (
                      <table className="table">
                        <tbody>
                          <tr>
                            <th style={{ color: "black" }}>Score</th>
                            <th style={{ color: "black" }}>Position</th>
                          </tr>
                          {Object.keys(sessionPLList)
                            .sort((a, b) => Number(a) - Number(b))
                            .map((key) => (
                              <tr key={key}>
                                <td style={{ color: "black" }}>{key}</td>
                                <td className={getColor(sessionPLList[key])}>
                                  {sessionPLList[key]}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MarketAnalysisBetfairFancy;
